import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext({
    theme: 'light',
    toggleTheme: () => {}
});

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('light');
    const [isLoaded, setIsLoaded] = useState(false);

    // Carregar tema do localStorage ao montar
    useEffect(() => {
        const savedTheme = localStorage.getItem('wgsol-theme') || 'light';
        setTheme(savedTheme);
        applyTheme(savedTheme);
        setIsLoaded(true);
    }, []);

    // Aplicar tema ao documento
    const applyTheme = (themeValue) => {
        const root = document.documentElement;
        const body = document.body;
        
        if (themeValue === 'dark') {
            // Aplicar no :root (html)
            root.setAttribute('data-theme', 'dark');
            // Aplicar no body (para modais do PrimeReact)
            body.setAttribute('data-theme', 'dark');
            body.classList.add('dark-theme');
            body.classList.remove('light-theme');
        } else {
            // Aplicar no :root (html)
            root.setAttribute('data-theme', 'light');
            // Aplicar no body (para modais do PrimeReact)
            body.setAttribute('data-theme', 'light');
            body.classList.add('light-theme');
            body.classList.remove('dark-theme');
        }
    };

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('wgsol-theme', newTheme);
        applyTheme(newTheme);
    };

    if (!isLoaded) {
        return <>{children}</>;
    }

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

// Hook customizado para usar o tema
export const useTheme = () => {
    const context = React.useContext(ThemeContext);
    // Se não estiver dentro do provider, retorna valor padrão em vez de lançar erro
    if (!context || !context.toggleTheme) {
        return {
            theme: 'light',
            toggleTheme: () => console.warn('useTheme: ThemeProvider não foi encontrado'),
        };
    }
    return context;
};
